<template>
<v-bottom-navigation
    :value="value"
    background-color="blue"
    color="white"
    horizontal
    class="elevation-0"
  >
    <v-btn @click="$router.push('/productos')">
      <span>Productos</span>

      <v-icon>mdi-package-variant-closed</v-icon>
    </v-btn>

    <v-btn @click="$router.push('/producto/existencias')">
      Existencias

      <v-icon>mdi-hexagon-slice-6</v-icon>
    </v-btn>

    <v-btn @click="$router.push('/producto/categorias')">
      <span>Categorias</span>

      <v-icon>mdi-file-replace-outline</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>
<script>

export default {
  name:'MenuProductos',
  props:['value']
//   data:()=>({
//     value:0
//   })
}
</script>